import Api from './api';
import Recipe from 'models/recipe';
import { JsonApiResponse, toJsonApiResponse } from 'utils/json-api';

export default class RecipesService {
    static async fetchRecipes(): Promise<JsonApiResponse<Recipe[]>> {
        let response = await Api.get('recipes', false);
        return await toJsonApiResponse<Recipe[]>(response);
    }
}